import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Video } from "@models/video-content";
import { deleteRequest, fetchRequest } from "@actions/video-content";
import VideosTable from "@components/video-contents/Table";
import TableRenderer from "@hocs/TableRenderer";
import { getVideoContentsList } from "@reducers/videoContent";
import VideoForm from "@components/video-contents/Form";
import { Button, Card, Col, Input, Row, Modal } from "antd";
import { FormattedMessage } from "react-intl";
import SearchVideosComponent from "@components/video-contents/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Video[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class VideosIndexPage extends React.Component<AllProps> {
  deleteVideo = (item: Video): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, currentPage, search } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/video-contents/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_video"
                defaultMessage={`Create Video`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header search-part`} bordered={false}>
            <SearchVideosComponent search={search} />
          </Card>
          <VideosTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteVideo}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ videoContents }: ApplicationState) => ({
  loading: videoContents.loading,
  data: getVideoContentsList(videoContents),
  count: videoContents.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(VideosIndexPage));
